export default __webpack_public_path__ + "static/media/product-9.d5447568.webp";